import SERVER_BASE_URL, { BASE_URL, API_URL } from '../../config';

const SERVER_URL = SERVER_BASE_URL;
export default SERVER_URL;
export const URL = SERVER_URL();
